import { App } from "vue"
import { AplosFileApiService } from "./components/FileManager/services/AplosFileApiService"
import { AnalysisWizardNavigationService } from "./components/AnalysisWizard/services/AnalysisWizardNavigationService"
import { DataCleaningSchemaService } from "./components/DataCleaning/services/DataCleaningSchemaService"
import { DataCleaningApiService } from "./components/DataCleaning/services/DataCleaningApiService"
import { CalculationSchemaService } from "./components/CustomCalculations/services/CalculationSchemaService"
import { CalculationsApiService } from "./components/CustomCalculations/services/CalculationApiService"
import { AvailableColumnsService } from "./components/DataCleaning/services/AvailableColumnsService"
import { PlottingSchemaService } from "./components/Plotting/services/PlottingSchemaService"
import { PlotsApiService } from "./components/Plotting/services/PlotApiService"
import { TablesSchemaService } from "./components/Tables/services/TableSchemaService"
import { TablesApiService } from "./components/Tables/services/TablesApiService"
import { AnalysisConfigSchemaService } from "./components/AnalysisConfig/services/AnalysisConfigSchemaService"
import { AnalysisConfigApiService } from "./components/AnalysisConfig/services/AnalysisConfigApiService"
import { AplosFileUploadService } from "./components/FileManager/services/AplosFileUploadService"
import { InjectableCtor, InjectableService } from "./shared/services/InjectableService"
import { AnalysisWizardFactory } from "./components/AnalysisWizard/services/AnalysisWizardFactory"
import { AnalysisWizardInitializationService } from "./components/AnalysisWizard/services/AnalysisWizardInitializationService"
import { CustomReportSchemaService } from "./components/CustomReports/services/CustomReportSchemaService"
import { CustomReportsApiService } from "./components/CustomReports/services/CustomReportApiService"
import { AdvancedAnalysisSchemaService } from "./components/AdvancedAnalysis/services/AdvancedAnalysisSchemaService"
import { AdvancedAnalysisApiService } from "./components/AdvancedAnalysis/services/AdvancedAnalysisApiService"
import { ExecutionPhaseService } from "./shared/Executions/services/ExecutionPhaseService"
import { ExecutionApiService } from "./shared/Executions/services/ExecutionApiService"
import { AnalysisConfigJsonParsingService } from "./components/AnalysisConfig/services/AnalysisConfigJsonParsingService"
import { CalculationsJsonParsingService } from "./components/CustomCalculations/services/CalculationsJsonParsingService"
import { DataCleaningJsonParsingService } from "./components/DataCleaning/services/DataCleaningJsonParsingService"
import { PlottingJsonParsingService } from "./components/Plotting/services/PlottingJsonParsingService"
import { TablesJsonParsingService } from "./components/Tables/services/TablesJsonParsingService"
import { CustomReportsJsonParsingService } from "./components/CustomReports/services/CustomReportsJsonParsingService"
import { AdvancedAnalysisJsonParsingService } from "./components/AdvancedAnalysis/services/AdvancedAnalysisJsonParsingService"
import { AdvancedAnalysisWizardFactory } from "./components/AdvancedAnalysisWizard/services/AdvancedAnalysisWizardFactory"
import { AdvancedAnalysisWizardInitializationService } from "./components/AdvancedAnalysisWizard/services/AdvancedAnalysisWizardInitializationService"
import { AdvancedAnalysisWizardNavigationService } from "./components/AdvancedAnalysisWizard/services/AdvancedAnalysisWizardNavigationService"
import { CdnSchemaFactory } from "./shared/CdnSchema/services/CdnSchemaFactory"
import { RuleOrderValidationService } from "./components/DataCleaning/services/RuleOrderValidationService"
import { RulesValidationService } from "./components/DataCleaning/services/RulesValidationService"
import { TemplateApiService } from "./components/TemplateManagement/services/TemplateApiService"
import { AuditLogApiService } from "./components/AuditLogViewer/services/AuditLogApiService"
import { LegacyApiService } from "./components/LegacyViewer/services/LegacyApiService"
import { MigrationApiService } from "./components/MigrationManagement/services/MigrationApiService"
import { FolderApiService } from "./components/ExecutionHistory/services/FolderApiService"


export default {
    install(app: App) {

        // File Services
        const aplosFileApiService = registerService(app, AplosFileApiService);
        registerService(app, AplosFileUploadService, aplosFileApiService);

        // Template Management
        registerService(app, TemplateApiService);

        // Audit Log
        registerService(app, AuditLogApiService);

        // Legacy Viewer
        registerService(app, LegacyApiService);

        // Migration Management
        registerService(app, MigrationApiService);

        // Executions
        const executionApiService = registerService(app, ExecutionApiService, aplosFileApiService);
        registerService(app, ExecutionPhaseService);
        registerService(app, FolderApiService);

        // Data Cleaning
        const dataCleaningSchemaService = registerService(app, DataCleaningSchemaService);
        const dataCleaningApiService = registerService(app, DataCleaningApiService, executionApiService);
        registerService(app, AvailableColumnsService);
        const dataCleaningJsonParsingService = registerService(app, DataCleaningJsonParsingService);
        const ruleOrderValidationService = registerService(app, RuleOrderValidationService);
        registerService(app, RulesValidationService, ruleOrderValidationService);


        // Analysis Configuration Services
        const analysisConfigSchemaService = registerService(app, AnalysisConfigSchemaService);
        registerService(app, AnalysisConfigApiService, executionApiService);
        const analysisConfigJsonParsingService = registerService(app, AnalysisConfigJsonParsingService);

        // Calculation Services
        const calculationSchemaService = registerService(app, CalculationSchemaService);
        registerService(app, CalculationsApiService, executionApiService);
        const calculationsJsonParsingService = registerService(app, CalculationsJsonParsingService);

        // Table Services
        const tablesSchemaService = registerService(app, TablesSchemaService);
        registerService(app, TablesApiService, executionApiService);
        const tablesJsonParsingService = registerService(app, TablesJsonParsingService);

        // Plot Services
        const plottingSchemaService = registerService(app, PlottingSchemaService);
        registerService(app, PlotsApiService, executionApiService);
        const plottingJsonParsingService = registerService(app, PlottingJsonParsingService);


        // Analysis Configuration Services
        const customReportSchemaService = registerService(app, CustomReportSchemaService);
        registerService(app, CustomReportsApiService, executionApiService);
        const customReportsJsonParsingService = registerService(app, CustomReportsJsonParsingService);

        // Advanced Analysis Services
        const advancedAnalysisSchemaService = registerService(app, AdvancedAnalysisSchemaService);
        registerService(app, AdvancedAnalysisApiService, executionApiService);
        registerService(app, AdvancedAnalysisJsonParsingService);

        // CdnSchema Shared Services
        const cdnSchemaFactory = registerService(app, CdnSchemaFactory,
            dataCleaningSchemaService,
            analysisConfigSchemaService,
            calculationSchemaService,
            plottingSchemaService,
            tablesSchemaService,
            customReportSchemaService,
            advancedAnalysisSchemaService
        );

        // Advanced Analysis Wizard Services
        registerLazyService(
            app,
            // use the same injectable key so existing injectors can keep using the key
            AdvancedAnalysisWizardFactory.injectableKey,
            () => import('./components/AdvancedAnalysisWizard/services/AdvancedAnalysisWizardFactory')
        );
        //registerService(app, AdvancedAnalysisWizardInitializationService)
        registerLazyService(
            app,
            // use the same injectable key so existing injectors can keep using the key
            AdvancedAnalysisWizardInitializationService.injectableKey,
            () => import('./components/AdvancedAnalysisWizard/services/AdvancedAnalysisWizardInitializationService'),
            aplosFileApiService,
            executionApiService,
            dataCleaningApiService,
            cdnSchemaFactory,
            dataCleaningJsonParsingService,
            analysisConfigJsonParsingService,
            calculationsJsonParsingService,
            tablesJsonParsingService,
            plottingJsonParsingService,
            customReportsJsonParsingService
        );
        registerService(app, AdvancedAnalysisWizardNavigationService)

        // Analysis Wizard
        registerService(app, AnalysisWizardNavigationService);
        //registerService(app, AnalysisWizardFactory);
        registerLazyService(
            app,
            // use the same injectable key so existing injectors can keep using the key
            AnalysisWizardFactory.injectableKey,
            () => import('./components/AnalysisWizard/services/AnalysisWizardFactory')
        );

        //registerService(app, AnalysisWizardInitializationService, aplosFileApiService, dataCleaningApiService, executionApiService);
        registerLazyService(
            app,
            // use the same injectable key so existing injectors can keep using the key
            AnalysisWizardInitializationService.injectableKey,
            () => import('./components/AnalysisWizard/services/AnalysisWizardInitializationService'),
            aplosFileApiService,
            dataCleaningApiService,
            executionApiService,
            cdnSchemaFactory,
            dataCleaningJsonParsingService,
            analysisConfigJsonParsingService,
            calculationsJsonParsingService,
            tablesJsonParsingService,
            plottingJsonParsingService,
            customReportsJsonParsingService
        );

    }
}

export function registerService<T extends InjectableService>(app: App, ctor: InjectableCtor<T>, ...ctorArgs: any[]): T {
    const instance = new ctor(...ctorArgs);
    app.provide(ctor.injectableKey, instance);
    return instance;
}

/**
 * Register a lazily-loaded service.
 * - key: stable string or symbol used by consumers to inject (avoid importing the heavy class/module when referencing the key)
 * - importer: dynamic import that yields the module exporting the constructor (default or named)
 * - ctorArgs: constructor args (can include instances created earlier)
 *
 * Consumers should inject the provider and await the result:
 *   const getFactory = InjectionService.injectStrict<() => Promise<AnalysisWizardFactory>>('AnalysisWizardFactory');
 *   const factory = await getFactory();
 */
export function registerLazyService<T extends InjectableService>(
    app: App,
    key: string,
    importer: () => Promise<any>,
    ...ctorArgs: any[]
) {
    let instancePromise: Promise<T> | null = null;

    // provide an async factory that returns the instance (created once)
    app.provide(key, async (): Promise<T> => {
        if (!instancePromise) {
            instancePromise = importer().then((mod) => {
                const C = (mod.default ?? Object.values(mod).find(v => typeof v === 'function')) as InjectableCtor<T>;
                if (!C) throw new Error('Lazy import did not expose a constructor');
                return new C(...ctorArgs);
            });
        }
        return instancePromise;
    });
}

